import { type ButtonHTMLAttributes, type ReactNode } from 'react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'ghost' | 'lime'
  children: ReactNode
}

export default function BigButton({ variant = 'primary', className = '', children, ...rest }: Props) {
  const base =
    'inline-flex items-center justify-center gap-2 px-6 py-3 font-display text-2xl uppercase tracking-display border-[3px] border-ink transition disabled:opacity-50 disabled:cursor-not-allowed select-none'
  const styles =
    variant === 'primary'
      ? 'bg-ink text-lime hover:bg-lime hover:text-ink hover:shadow-block'
      : variant === 'lime'
      ? 'bg-lime text-ink hover:bg-ink hover:text-lime hover:shadow-block'
      : 'bg-transparent text-ink hover:bg-lime'
  return (
    <button {...rest} className={`${base} ${styles} ${className}`}>
      {children}
    </button>
  )
}
